const prefix = '@page';

export const FETCH_PAGE_REQUEST = `${prefix}/FETCH_PAGE_REQUEST`;
export const FETCH_PAGE_SUCCESS = `${prefix}/FETCH_PAGE_SUCCESS`;
export const FETCH_PAGE_FAILURE = `${prefix}/FETCH_PAGE_FAILURE`;

export const FETCH_COMPOSITE_DETAIL_REQUEST = `${prefix}/FETCH_COMPOSITE_DETAIL_REQUEST`;
export const FETCH_COMPOSITE_DETAIL_SUCCESS = `${prefix}/FETCH_COMPOSITE_DETAIL_SUCCESS`;
export const FETCH_COMPOSITE_DETAIL_FAILURE = `${prefix}/FETCH_COMPOSITE_DETAIL_FAILURE`;
